import { useQuery } from "@apollo/client";
import { useState } from "react";

import useDebouncedState from "~/shared/hooks/useDebouncedState";

import { SpeciesSelectElement_SpeciesSearchDocument } from "./queries.generated";

type UseSpeciesSearchParams = {
    excludeAssignedToResearchTypeId?: string;
};

export function useSpeciesSearch({ excludeAssignedToResearchTypeId }: UseSpeciesSearchParams) {
    const [isOpen, setOpen] = useState(false);
    const [inputText, searchText, setInputText] = useDebouncedState<string>("", 300);

    const { data: dataSuggestions, loading: isSuggestionsLoading } = useQuery(SpeciesSelectElement_SpeciesSearchDocument, {
        variables: { params: { q: searchText, excludeAssignedToResearchTypeId } },
        skip: !isOpen,
    });

    return {
        isOpen,
        setOpen,
        inputText,
        setInputText,
        searchText,
        options: dataSuggestions?.settingsSpeciesGetAll.data ?? [],
        loading: isSuggestionsLoading,
    };
}
